const Initialarray = {
    observation_id: null,
    observation_date: null,
    time: null,
    shift: null,
    type_of_observed_people: null,
    area: null,
    site: null,
    siteid: null,
    areaid: null,
}

export default function Set_Basic_Info(state = Initialarray, action) {
    switch (action.type) {
        case "SET_BASIC_INFO":
            state = {
                ...state,
                observation_id: action.observation_id,
                observation_date: action.observation_date,
                time: action.time,
                shift: action.shift,
                type_of_observed_people: action.type_of_observed_people,
                area: action.area,
                site: action.site
            }
            break;
        case "SET_AREAID":
            state = {
                ...state,
                areaid: action.areaid,
            }
            break;
        case "SET_SITEID":
            state = {
                ...state,
                siteid: action.siteid,
            }
            break;
        case "CLEAR_SITE":
            state = {
                ...state,
                site: null
            }
            break;
        case "CLEAR_BASIC_INFO":
            state = {
                ...state,
                observation_id: null,
                observation_date: null,
                time: null,
                shift: null,
                type_of_observed_people: null,
                area: null,
                site: null,
                areaid: null,
                siteid: null,
            }
            break;

        default:

            break;
    }
    return state;
}